import { userPrivacySetting } from '@/Models';
import { consentManager } from './ConsentManager';
import { analyticsPluginName } from '@/Utils/AnalyticsUtility';
import Config from '@/Config';

/**
 * @param {object} analyticsConfig - analyticsConfig from InitialState
 */
export default function googleAdsPlugin(analyticsConfig) {
    const { googleAdsId, pageViewEventId } = analyticsConfig.googleAds;
    const platformName = Config.platformName.toLowerCase();

    consentManager.register(analyticsPluginName.googleAds, userPrivacySetting.marketing, () => {
        window.gtag('config', googleAdsId, { groups: `${platformName}-ads`, cookie_domain: window.location.hostname });

        if (pageViewEventId) {
            window.gtag('event', 'conversion', { send_to: pageViewEventId, groups: `${platformName}-ads` });
        }
    });

    return {
        name: analyticsPluginName.googleAds,
        config: analyticsConfig,
        track: () => {},
    };
}
